import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthProvider from './app/Context/auth';

// Componentes e Páginas
import Site from './site/site';
import Login from './app/Login/login';
import NovaConta from './app/NovaConta/novaconta';
import ResetSenha from './app/ResetSenha/resetsenha';
import Home from './app/Home/home';
import MinhaConta from './app/MinhaConta/minhaConta';

// Componente para proteger rotas
import PrivateRoute from './app/Components/PrivateRoute/PrivateRoute';
import SystemLogsTenant from './app/Config/SystemLogsTenant'; // Import Logs Tenant
import Empresas from './app/Empresas/empresas';
import NovaEmpresa from './app/Empresas/novaempresa';
import EditarEmpresa from './app/Empresas/editarempresa';
import Marcas from './app/Marcas/Marcas';
import NovaMarca from './app/Marcas/novamarca';
import EditarMarca from './app/Marcas/editarmarca';
import UnidadesMedida from './app/UnidadeMedida/UnidadeMedida';
import NovaUnidadeMedida from './app/UnidadeMedida/NovaUnidadeMedida';
import EditarUnidadeMedida from './app/UnidadeMedida/EditarUnidadeMedida';
import Grades from './app/Grades/Grades';
import NovaGrade from './app/Grades/NovaGrade';
import EditarGrade from './app/Grades/EditarGrade';
import Produtos from './app/Produtos/Produtos';
import NovoProduto from './app/Produtos/NovoProduto';
import EditarProduto from './app/Produtos/EditarProduto';
import AReceber from './app/Financeiro/AReceber/AReceber';
import APagar from './app/Financeiro/APagar/APagar';
import APagarForm from './app/Financeiro/APagar/APagarForm'; // New Import
import AReceberForm from './app/Financeiro/AReceber/AReceberForm'; // New Import
import DashboardFinanceiro from './app/Financeiro/Dashboard/DashboardFinanceiro'; // Import Dashboard Financeiro
import DashboardVendas from './app/Vendas/Dashboard/DashboardVendas'; // Import Dashboard Vendas

import Pedidos from './app/Pedidos/Pedidos';
import NovoPedido from './app/Pedidos/novopedido';
import EditarPedido from './app/Pedidos/editarpedido';
import Movimentacoes from './app/Movimentacoes/Movimentacoes';
import NovaMovimentacao from './app/Movimentacoes/NovaMovimentacao';
import EditarMovimentacao from './app/Movimentacoes/EditarMovimentacao';
import Estoque from './app/Estoque/Estoque';
import Clientes from './app/Gerencial/Clientes/clientes';
import ClienteForm from './app/Gerencial/Clientes/ClienteForm'; // Import do Form
import DashboardGerencial from './app/Gerencial/Dashboard/Dashboard'; // Import Dashboard
import SystemLogsAdmin from './app/Gerencial/Logs/SystemLogsAdmin'; // Import Logs Admin
import Modulos from './app/Gerencial/Modulos/Modulos'; // Import Modulos

import RelatorioPedidoPage from './Pages/RelatorioPedidoPage';
import Insumos from './app/Insumos/insumos';
import NovoInsumo from './app/Insumos/novoInsumo';
import EditarInsumo from './app/Insumos/editarInsumo';
import EtapasProducao from './app/EtapasProducao/EtapasProducao';
import NovaEtapaProducao from './app/EtapasProducao/NovaEtapaProducao';
import EditarEtapaProducao from './app/EtapasProducao/EditarEtapaProducao';
import Producao from './app/Producao/producao';
import NovaProducao from './app/Producao/NovaProducao';
import EditarProducao from './app/Producao/EditarProducao';
import Usuarios from './app/usuarios/usuarios';
import NovoUsuario from './app/usuarios/NovoUsuario';
import EditarUsuario from './app/usuarios/EditarUsuario';


import TermsModal from './app/Components/TermsModal/TermsModal'; // Import TermsModal
import { useAuth } from './app/Context/auth'; // Import useAuth


const TermsCheck = () => {
  const { appUserData, logado, loading } = useAuth();
  // Só mostra se estiver logado, carregado e não tiver aceitado os termos
  const show = !loading && logado && appUserData && !appUserData.terms_accepted_at;
  return <TermsModal show={!!show} />;
};

function App() {
  return (
    // O AuthProvider deve envolver todas as rotas para gerenciar o estado de autenticação
    <AuthProvider>
      <TermsCheck />
      <BrowserRouter>
        <Routes>
          {/* Rotas Públicas */}
          <Route path='/' element={<Site />} />
          <Route path='/app' element={<Login />} />
          <Route path='/app/novaconta' element={<NovaConta />} />
          <Route path='/app/resetsenha' element={<ResetSenha />} />

          {/* Rotas Privadas (Protegidas) */}
          <Route path='/app/home' element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path='/app/minhaconta' element={<PrivateRoute><MinhaConta /></PrivateRoute>} />
          <Route path='/app/empresas' element={<PrivateRoute><Empresas /></PrivateRoute>} />
          <Route path='/app/novaempresa' element={<PrivateRoute><NovaEmpresa /></PrivateRoute>} />
          <Route path='/app/editarempresa/:id' element={<PrivateRoute><EditarEmpresa /></PrivateRoute>} />
          <Route path='/app/marcas' element={<PrivateRoute><Marcas /></PrivateRoute>} />
          <Route path='/app/novamarca' element={<PrivateRoute><NovaMarca /></PrivateRoute>} />
          <Route path='/app/editarmarca/:id' element={<PrivateRoute><EditarMarca /></PrivateRoute>} />
          <Route path='/app/unidadesmedida' element={<PrivateRoute><UnidadesMedida /></PrivateRoute>} />
          <Route path='/app/novaunidademedida' element={<PrivateRoute><NovaUnidadeMedida /></PrivateRoute>} />
          <Route path='/app/editarunidademedida/:id' element={<PrivateRoute><EditarUnidadeMedida /></PrivateRoute>} />
          <Route path='/app/grades' element={<PrivateRoute><Grades /></PrivateRoute>} />
          <Route path='/app/novagrade' element={<PrivateRoute><NovaGrade /></PrivateRoute>} />
          <Route path='/app/editargrade/:id' element={<PrivateRoute><EditarGrade /></PrivateRoute>} />
          <Route path='/app/insumos' element={<PrivateRoute><Insumos /></PrivateRoute>} />
          <Route path='/app/novoinsumo' element={<PrivateRoute><NovoInsumo /></PrivateRoute>} />
          <Route path='/app/editarinsumo/:id' element={<PrivateRoute><EditarInsumo /></PrivateRoute>} />
          <Route path='/app/produtos' element={<PrivateRoute><Produtos /></PrivateRoute>} />
          <Route path='/app/novoproduto' element={<PrivateRoute><NovoProduto /></PrivateRoute>} />
          <Route path='/app/editarproduto/:id' element={<PrivateRoute><EditarProduto /></PrivateRoute>} />
          <Route path='/app/financeiroareceber' element={<PrivateRoute><AReceber /></PrivateRoute>} />
          <Route path='/app/financeiroareceber/novo' element={<PrivateRoute><AReceberForm /></PrivateRoute>} />
          <Route path='/app/financeiroareceber/editar/:id' element={<PrivateRoute><AReceberForm /></PrivateRoute>} />
          <Route path='/app/financeiroapagar' element={<PrivateRoute><APagar /></PrivateRoute>} />
          <Route path='/app/financeiroapagar/novo' element={<PrivateRoute><APagarForm /></PrivateRoute>} />
          <Route path='/app/financeiroapagar/editar/:id' element={<PrivateRoute><APagarForm /></PrivateRoute>} />
          {/* Nova rota Dashboard Financeiro */}
          <Route path='/app/financeiro/dashboard' element={<PrivateRoute><DashboardFinanceiro /></PrivateRoute>} />



          {/* Rota Dashboard Vendas */}
          <Route path='/app/vendas/dashboard' element={<PrivateRoute><DashboardVendas /></PrivateRoute>} />
          <Route path='/app/pedidos' element={<PrivateRoute><Pedidos /></PrivateRoute>} />
          <Route path='/app/novopedido' element={<PrivateRoute><NovoPedido /></PrivateRoute>} />
          <Route path='/app/editarpedido/:id' element={<PrivateRoute><EditarPedido /></PrivateRoute>} />
          <Route path='/app/movimentacoes' element={<PrivateRoute><Movimentacoes /></PrivateRoute>} />
          <Route path='/app/novamovimentacao' element={<PrivateRoute><NovaMovimentacao /></PrivateRoute>} />
          <Route path='/app/editarmovimentacao/:id' element={<PrivateRoute><EditarMovimentacao /></PrivateRoute>} />
          <Route path='/app/estoque' element={<Estoque />} />
          <Route path='/app/gerencial/clientes' element={<PrivateRoute><Clientes /></PrivateRoute>} />
          <Route path='/app/gerencial/dashboard' element={<PrivateRoute><DashboardGerencial /></PrivateRoute>} />
          <Route path='/app/gerencial/clientes/novo' element={<PrivateRoute><ClienteForm /></PrivateRoute>} />
          <Route path='/app/gerencial/clientes/editar/:id' element={<PrivateRoute><ClienteForm /></PrivateRoute>} />
          <Route path='/app/gerencial/logs' element={<PrivateRoute><SystemLogsAdmin /></PrivateRoute>} />
          <Route path='/app/gerencial/modulos' element={<PrivateRoute><Modulos /></PrivateRoute>} />
          <Route path='/app/config/logs' element={<PrivateRoute><SystemLogsTenant /></PrivateRoute>} />
          <Route path='/app/pedidos/imprimir/:id' element={<PrivateRoute><RelatorioPedidoPage /></PrivateRoute>} />
          <Route path="/app/etapas-producao" element={<PrivateRoute><EtapasProducao /></PrivateRoute>} />
          <Route path="/app/nova-etapa" element={<PrivateRoute><NovaEtapaProducao /></PrivateRoute>} />
          <Route path="/app/editar-etapa/:id" element={<PrivateRoute><EditarEtapaProducao /></PrivateRoute>} />
          <Route path="/app/producao" element={<PrivateRoute><Producao /></PrivateRoute>} />
          <Route path="/app/nova-producao" element={<PrivateRoute><NovaProducao /></PrivateRoute>} />
          <Route path="/app/editar-producao/:id" element={<PrivateRoute><EditarProducao /></PrivateRoute>} />
          <Route path="/app/usuarios" element={<PrivateRoute><Usuarios /></PrivateRoute>} />
          <Route path="/app/novousuario" element={<PrivateRoute><NovoUsuario /></PrivateRoute>} />
          <Route path="/app/editarusuario/:id" element={<PrivateRoute><EditarUsuario /></PrivateRoute>} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;